export default "__VITE_ASSET__DRaEGp_M__"